import React from "react";
import type { FilterProps, SelectionEvent, SelectOption } from "../../../../viewmodels/qaReports/qaReportTypes";
import ProductPluSearch from "../ProductPluSearch";
// @ts-expect-error The legacy select wrapper has no TypeScript declarations.
import SelectMenu from "../../../controls/SelectMenu";

export default function QaReceivingOptions(props: FilterProps & { suppliers: SelectOption[]; categories: SelectOption[] }) {
  const { filters, setFilters, suppliers, categories, logout, disabled } = props;
  return (
    <div className="grid grid-cols-6 gap-3">
      <SelectMenu
        title="Supplier"
        disabled={disabled}
        parentClass="col-span-6 sm:col-span-3 lg:col-span-2"
        handleInputChange={(e: SelectionEvent) =>
          setFilters({ ...filters, supplier: e.target.value })
        }
        name="supplier"
        options={suppliers}
        value={filters.supplier}
      />
      <SelectMenu
        title="Category"
        disabled={disabled}
        parentClass="col-span-6 sm:col-span-3 lg:col-span-2"
        handleInputChange={(e: SelectionEvent) =>
          setFilters({ ...filters, category: e.target.value })
        }
        name="category"
        options={categories}
        value={filters.category}
      />
      <ProductPluSearch
        value={filters.product}
        onChange={(product) => setFilters({ ...filters, product })}
        logout={logout}
        disabled={disabled}
        allowAll
      />
    </div>
  );
}
